<section class="py-5">
    <div class="container-fluid mt-3">
        <div class="row justify-content-center">
            <div class="col-10 text-start">
                <section class="">
                

                    <h1>Privacy Policy</h1>
                    <p><strong>Effective Date:</strong> 01/04/2025</p>
                    <p>Welcome to GeoTracing ("we," "our," or "us"). Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website <a href="https://geotracing.varnik.cloud/">https://geotracing.varnik.cloud/</a> (the "Website").</p>
                    <p>By accessing or using the Website, you agree to the terms of this Privacy Policy. If you do not agree, please do not use the Website.</p>
                    
                    <h2>1. Information We Collect</h2>
                    <h3>1.1 Personal Information</h3>
                    <p>We may collect personal information that you voluntarily provide, such as:</p>
                    <ul>
                        <li>Name</li>
                        <li>Email address</li>
                        <li>Contact number</li>
                        <li>Any other information you submit via forms</li>
                    </ul>
                    
                    <h3>1.2 Non-Personal Information</h3>
                    <p>We may automatically collect non-personal information, including:</p>
                    <ul>
                        <li>IP address</li>
                        <li>Browser type and version</li>
                        <li>Device type</li>
                        <li>Pages visited and time spent on the Website</li>
                        <li>Cookies and tracking technologies</li>
                    </ul>
                    
                    <h2>2. How We Use Your Information</h2>
                    <ul>
                        <li>Provide and improve our services</li>
                        <li>Respond to inquiries and support requests</li>
                        <li>Enhance user experience and website functionality</li>
                        <li>Analyze usage trends and improve security</li>
                        <li>Send updates, notifications, or promotional content (with your consent)</li>
                    </ul>
                    
                    <h2>3. How We Share Your Information</h2>
                    <p>We do not sell, trade, or rent your personal information. However, we may share information in the following cases:</p>
                    <ul>
                        <li><strong>Service Providers:</strong> With third-party vendors who assist us in operating our Website.</li>
                        <li><strong>Legal Compliance:</strong> If required by law or in response to legal processes.</li>
                        <li><strong>Business Transfers:</strong> In case of a merger, sale, or transfer of assets.</li>
                    </ul>
                    
                    <h2>4. Cookies and Tracking Technologies</h2>
                    <p>We use cookies and similar technologies to improve user experience. You can manage cookie settings through your browser.</p>
                    
                    <h2>5. Data Security</h2>
                    <p>We implement appropriate security measures to protect your personal information. However, no method of data transmission or storage is 100% secure.</p>
                    
                    <h2>6. Third-Party Links</h2>
                    <p>Our Website may contain links to third-party websites. We are not responsible for their privacy practices.</p>
                    
                    <h2>7. Your Rights and Choices</h2>
                    <ul>
                        <li>Access, update, or delete your personal information</li>
                        <li>Opt out of promotional emails</li>
                        <li>Disable cookies through browser settings</li>
                    </ul>
                    
                    <h2>8. Changes to This Privacy Policy</h2>
                    <p>We may update this Privacy Policy periodically. The latest version will be posted on this page with the updated effective date.</p>
                    
                    <h2>9. Contact Us</h2>
                    <p class="contact">For any questions or concerns regarding this Privacy Policy, please contact us at <a href="mailto:Vsspl_affairs@msservicesinc.com">Vsspl_affairs&#64;msservicesinc.com</a>.</p>
                    
                </section>

                    

            </div>
        </div>
    </div>
</section>
